import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Navbar = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = async () => {
        try {
            const response = await axios.get('/api/auth/check', { withCredentials: true });
            setIsAuthenticated(response.data.isAuthenticated);
            if (response.data.user) {
                setUser(response.data.user);
            }
        } catch (error) {
            console.error('Error checking auth status:', error);
        }
    };

    const handleLogout = async () => {
        try {
            await axios.get('/login/logout', { withCredentials: true });
            setIsAuthenticated(false);
            setUser(null);
            // Redirigir a la página principal de Express
            window.location.href = '/';
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container-fluid mx-5">
                <a className="navbar-brand" href="/">
                    DubbiDan&nbsp;
                    <img src="/images/Dan.png" alt="DubbiDan Logo" width="23" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav mx-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="/TuRepositorio">Tu Repositorio</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/Trabajos">Trabajos</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/Actores">Actores</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/Contacto">Contacto</a>
                        </li>
                    </ul>
                    {isAuthenticated ? (
                        <button className="btn btn-custom" onClick={handleLogout}>
                            <span className="text-primary">Cerrar Sesión</span>
                        </button>
                    ) : (
                        <a className="btn btn-custom" href="/login">
                            <span className="text-primary">Empieza Ahora</span>
                        </a>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;